import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prg-buttons',
  templateUrl: './buttons.component.html'
})
export class ButtonsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-buttons/buttons.component.ts